import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {withStyles} from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip/Chip";
import {FormattedDate} from "react-intl";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";

class CustomerGrid extends React.Component {
    render() {
        const {boards, role, classes} = this.props;

        return (
            <section>
                <Grid container spacing={16}>
                    {boards.map(board => {

                        let fullname = board.customer_name

                        return (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={board.id}>
                                <Card>
                                    <a href={`/customers/${board.id}`} style={{textDecoration: 'none'}}>
                                        <CardContent className={classes.cardContent}>
                                            <Grid container spacing={8} justify="space-between" alignItems="center">
                                                <Grid item xs={12}>
                                                    <Typography variant="h6" component="h2">
                                                        <EllipisWithTooltip>{fullname}</EllipisWithTooltip>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography>
                                                        {i18n.get('boards.customer_number')}: {board.customer_number}
                                                    </Typography>
                                                </Grid>
                                                {board.street && (
                                                    <Grid item xs={12}>
                                                        <Typography>
                                                            <span>
                                                                {board.street} {board.housenumber || ''} <br/>
                                                                {board.zip || ''} {board.city || ''}
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                )}
                                                {board.first_name && board.last_name && (
                                                    <Grid item xs={12}>
                                                        <Typography>
                                                            {`${board.first_name} ${board.last_name}`}
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </CardContent>
                                    </a>

                                    {/*<Divider />*/}

                                    {/*<CardContent>*/}
                                    {/*    <Grid container spacing={8} justify="space-between" alignItems="center">*/}
                                    {/*        <Grid item xs={6}>*/}
                                    {/*            <Typography>*/}
                                    {/*                {i18n.get('cooperations.contracts')}:*/}
                                    {/*            </Typography>*/}
                                    {/*        </Grid>*/}
                                    {/*        <Grid item xs={6}>*/}
                                    {/*            <Typography>*/}
                                    {/*                {i18n.get('persons.students')}: {board.students.length}*/}
                                    {/*            </Typography>*/}
                                    {/*        </Grid>*/}
                                    {/*    </Grid>*/}
                                    {/*</CardContent>*/}

                                    <Divider />

                                    <CardActions className={classes.cardActions}>
                                        <Grid container justify="space-between" alignItems="center">
                                            <Grid item>
                                                {/*{board.website && (*/}
                                                {/*    <Tooltip placement="bottom-start" title={board.website} classes={{tooltip : classes.popper}}>*/}
                                                {/*        <IconButton href={`${board.website}`} className={classes.iconButton}>*/}
                                                {/*            <Icon className={classes.iconButtonIcon}>web</Icon>*/}
                                                {/*        </IconButton>*/}
                                                {/*    </Tooltip>*/}
                                                {/*)}*/}

                                                {board.email && (
                                                    <Tooltip placement="bottom-start" title={board.email} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`mailto:${board.email}`} className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>alternate_email</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {board.telephone && (
                                                    <Tooltip placement="bottom-start" title={board.telephone} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`tel:${board.telephone}`} className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>phone</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {board.website && (
                                                    <Tooltip placement="bottom-start" title={board.website} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`${board.website}`} target='_blank' className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>web</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Grid>

                                            {role !== 'technician' &&
                                            <Grid item>
                                                <IconButton href={`/customers/${board.id}/edit`}
                                                            className={classes.iconButton}>
                                                    <Icon className={classes.iconButtonIcon}>edit</Icon>
                                                </IconButton>

                                                <Tooltip placement="bottom-end" title={i18n.get('boards.show_more')}
                                                         classes={{tooltip: classes.popper}}>
                                                    <IconButton href={`/customers/${board.id}`}
                                                                className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>arrow_forward</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            }
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </section>
        )
    }
}

const styles = theme => ({
    cardContent: {
        minHeight: '150px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    }
});

export default withStyles(styles)(CustomerGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Customers/CustomerGrid.js